<template>
  <div class="chart-one">
    <div class="box">
      <h1>受影响资产国家分布情况</h1>
        <div class="country-container">
            <div class="country-first">
              <img src="@/assets/newTheatre/EffectTwo.png" alt="">
              <h2>{{second.count}}</h2>
              <div class="flag">
                <img :src="getPng(second.name)" alt="">
              </div>
            </div>
            <div class="country-center">
              <img src="@/assets/newTheatre/EffectOneBorder.png" alt="">
              <div class="centreIn">
                <h2>{{first.count}}</h2>
                <img src="@/assets/newTheatre/EffectOne.png" alt="">
                <div class="center3D">
                  <img src="@/assets/newTheatre/EffectOneIn.png" alt="">
                </div>
              </div>

              <div class="flag">
                <img :src="getPng(first.name)" alt="">
              </div>

            </div>
            <div class="country-first">
              <img src="@/assets/newTheatre/EffectTwo.png" alt="">
              <h2>{{third.count}}</h2>
              <div class="flag">
                <img :src="getPng(third.name)" alt="">
              </div>
            </div>

            </div>
        </div>
    </div>

</template>
<style scoped lang="less">
.chart-one {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  font-family: 'YouSheBiaoTiHei';
}
.box {
  color: rgba(255, 255, 255, 1);
}
h1{
  color: rgba(241, 237, 255, 1);
  font-size: 24px;
  height: 31px;
  padding-top: 12px;
  padding-left: 39px;
  padding-bottom: 14px;
  text-shadow: 0 2px 20px rgba(42, 56, 180, 1);
  text-align: left;
}
img{
  width: 100%;
    height: 100%;
}

.country-container {
  width: 100%;
  box-sizing: border-box;
  padding-left: 33px;
  padding-right: 27px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .country-first {
    width: 109px;
    height: 138px;
    position: relative;
    h2{
      font-size:14px;
      color: rgba(187, 198, 255, 1);
      position: absolute;
      top: 22px;
      left: 50%;
      transform:translateX(-50%);
    }
    //background-color: #5E6EFF;
  }
  .country-center {
    width: 139px;
    height: 176px;
    position: relative;
    //background-color: #00F0FF;
    .flag{
      width: 50px;
      position: absolute;
      top: -12px;
      left: -4px;
    }
    h2{
      font-size:18px;
      position: absolute;
      top: 20px;
        left: 50%;
        transform:translateX(-50%);
    }
    .centreIn{
      width: 120px;
      height: 154px;
      position: absolute;
      left: 10px;
      top: 10px;
      .center3D{
        width: 82px;
        position: absolute;
        left: 18px;
        top: 22px;
      }
    }
  }
  .flag{
    width: 32px;
    position: absolute;
    top: -15px;
  }
}
</style>
<script>
import {getAffectedCountry} from "@/service/dashboard";
import store from "@/store";
import {countryChineseDict, countryDict} from "@/theme/dict";
export default {
  data() {
    return {
      first: {name: "CN", count: 0},
      second: {name: "CN", count: 0},
      third: {name: "CN", count: 0}
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getPng(name) {
      return require(`../../assets/Flags/${name}.png`);
    },
    getData() {
      getAffectedCountry().then(res => {
        if (res[store.state.dict.threatId]) {
          const origin = res[store.state.dict.threatId].sort((a,b) => b.count - a.count);

          this.first = origin[0];
          this.second = origin[1];
          this.third = origin[2];
        }
      });
    }
  }
};
</script>